import { User } from "./user";
import { Laverie } from "./laverie";
import { Account } from "./account";
import { Product } from "./product";


export interface BonInstallation {
    account: Account
    laverie: Laverie
    products: Product[]
    installDate?: Date
    contactSecond: User
    cleCaisse: string
    cleTrappe: string
    autreCle: string
    installedBy: User
}

export class BonInstallationGen {
    // laverie.numeroDeContrat
    lnc: string

    // laverie.name
    ln: string

    // laverie.address.ville
    lav: string

    // laverie.address.numero
    lan: string

    // laverie.address.rue
    lar: string

    // laverie.address.codepostale
    lacp: string

    // laverie.codeAcces
    a: string
    ha: boolean

    // products for the laverie
    lp: Product[]

    // installDate
    id: string
    hid: boolean

    // contactPrincipal.name
    cpn: string
    hcpn: boolean

    // contactPrincipal.fonction
    cpf: string
    hcpf: boolean

    // contactPrincipal.telephone
    cpt: string
    hcpt: boolean

    // contactPrincipal.mobile
    cpm: string
    hcpm: boolean

    // contactSecond.name
    csn: string
    hcsn: boolean

    // contactSecond.fonction
    csf: string
    hcsf: boolean

    // contactSecond.telephone
    cst: string
    hcst: boolean

    // contactSecond.mobile
    csm: string
    hcsm: boolean

    // cleCaisse 
    cc: string
    hcc: boolean

    // cleTrappe
    ct: string
    hct: boolean

    // autreCle
    ac: string
    hac: boolean

    // installedBy.name
    ibn: string
    hibn: boolean

    // installedBy.lastname
    ibl: string
    hibl: boolean
}

export function flattenBonInstallation(input: BonInstallation): BonInstallationGen {
    const b = new BonInstallationGen();
    if (input.laverie) {
        b.ln = input.laverie.name
        b.lnc = input.laverie.numeroDeContrat.toString()
        b.lan = input.laverie.address.numero
        b.lar = input.laverie.address.rue
        b.lav = input.laverie.address.ville
        b.lacp = input.laverie.address.codepostale
        b.lp = input.products
        if (input.laverie.codeAcces) {
            b.a = input.laverie.codeAcces
            b.ha = true
        } else {
            b.ha = false
        }
    }
    if (input.installDate) {
        b.id = input.installDate.toString()
        b.hid = true
    } else {
        b.hid = false
    }

    if (input.laverie && input.laverie.gestionnaire) {
        b.cpn = input.laverie.gestionnaire
        b.hcpn = true
    } else {
        b.hcpn = false
    }

    b.cpf = "Gestionnaire"
    b.hcpf = true

    if (input.laverie && input.laverie.telephoneAutre) {
        b.cpt = input.laverie.telephoneAutre
        b.hcpt = true
    } else {
        b.hcpt = false
    }
    if (input.laverie && input.laverie.telephonePrincipal) {
        b.cpm = input.laverie.telephonePrincipal
        b.hcpm = true
    } else {
        b.hcpm = false
    }

    if (input.contactSecond) {
        if (input.contactSecond.name) {
            b.csn = input.contactSecond.name
            b.hcsn = true
        } else {
            b.hcsn = false
        }
        if (input.contactSecond.fonction) {
            b.csf = input.contactSecond.fonction
            b.hcsf = true
        } else {
            b.hcsf = false
        }
        if (input.contactSecond.telephone) {
            b.cst = input.contactSecond.telephone
            b.hcst = true
        } else {
            b.hcst = false
        }
        if (input.contactSecond.mobile) {
            b.csm = input.contactSecond.mobile
            b.hcsm = true
        } else {
            b.hcsm = false
        }
    }
    if (input.cleCaisse) {
        b.cc = input.cleCaisse
        b.hcc = true
    } else {
        b.hcc = false
    }
    if (input.cleTrappe) {
        b.ct = input.cleTrappe
        b.hct = true
    } else {
        b.hct = false
    }
    if (input.autreCle) {
        b.ac = input.autreCle
        b.hac = true
    } else {
        b.hac = false
    }
    if (input.installedBy) {
        if (input.installedBy.name) {
            b.ibn = input.installedBy.name
            b.hibn = true
        } else {
            b.hibn = false
        }
        if (input.installedBy.lastname) {
            b.ibl = input.installedBy.lastname
            b.hibl = true
        } else {
            b.hibl = false
        }
    } else {
        b.hibn = false
        b.hibl = false
    }
    return b
}
